import { Team } from "../../../types/calendarSettings"
import labels from "../../../utils/labels"
import TeamSettingsRow from "./TeamSettingsRow"
import RowCell from "../../UI/table/RowCell"

const TeamSettingsList = ({
  teams,
  onTeamNameUpdate,
  onTeamGroupChange
}: {
  teams: Team[]
  onTeamNameUpdate: (hexcode: string, newName: string) => void,
  onTeamGroupChange: (hexCode: string, isGroup: boolean) => void
}) => {
  return (
    <ul className="flex flex-col">
      <li className="flex" data-header>
        <RowCell width={174}>{labels.nexusTeamHex}</RowCell>
        <RowCell>{labels.pondooTeamName}</RowCell>
        <RowCell>{labels.groupEmployeesInTeams}</RowCell>
      </li>
      {teams.map(team =>
        <TeamSettingsRow
          key={team.hexCode}
          colorHex={team.hexCode}
          chipColor={team.hexCode}
          teamName={team.teamName}
          onNameChange={(newName) => onTeamNameUpdate(team.hexCode, newName)}
          grouped={team.grouped}
          onGroupChange={(isGroup) => onTeamGroupChange(team.hexCode, isGroup)} />
      )}
    </ul>
  )
}

export default TeamSettingsList